import { styled } from "@mui/material/styles";

export const PageContent = styled("div")`
  height: 100vh;
  position: relative;
  z-index: 1;
`;
